// Module
var code = "<div data-id=\"spinner\" class=\"spinner-border spinner-fill\" role=\"status\"></div> <div data-id=\"chart-canvas-container\" style=\"overflow:hidden\"> <canvas data-id=\"canvas\" height=\"320\" style=\"display:none\"></canvas> </div> ";
// Exports
export default code;